import React, { useState, useEffect, useCallback, useContext, useMemo, useRef } from "react";
import { Button, Container, Row, Col, Form, Modal } from 'react-bootstrap';
import { API, graphqlOperation } from 'aws-amplify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { currencyFormat, i18nValue } from '../functions';
import { NavLink } from 'react-router-dom';
import Screen from '../components/Screen';
import { getCDNImage } from '../globals';
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { CheckInContext } from "../context/checkin";
import { useParams } from 'react-router';
import { T, TF } from 'react-translator-component';
import { faThumbsUp, faImage, faInfoCircle, faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { Warning } from "../components/Icons";
import useUpsell from "../hooks/useUpsells";
import DateSelector from "../components/UpSelling/DateSelectorModal";
import processHtml from '../components/processHtml';
import Settings from "../components/UpSelling/Settings";
import { PaymentCart } from "../components/PaymentCart";
import { getQuantityFromValues, getSettingsBookButtonDisabled } from "../components/UpSelling/QuestionTotals.utils";
import { shouldHidePrice, parseOptionSettings, hasSettingsQuestions } from "../components/UpSelling/upSellingUtils";
import { useNavigate } from "react-router-dom";
import { isAlvarezArguellez } from "../components/CheckIn/hotelConditions";

const HOTEL_IDS_WITHOUT_UPSELLING_PAY_LATER = [
  "efcf9764-9157-4454-9d24-76a053906322", // sigma - ex betahouse
  // "511e8df9-672d-42b1-9711-d82beb7baf64", // dev
];

const shouldShowUpsellingPayLaterOption = (hotelId) => {
  if (!hotelId) return true;
  // Centralizamos esta regla para moverla luego a config remota/local.
  return !HOTEL_IDS_WITHOUT_UPSELLING_PAY_LATER.includes(hotelId);
};

const UpsellingDetail = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const refItemsContainer = useRef(null);

  const [withPaymentStep, setWithPaymentStep] = useState(true);

  const { data: hotel, sectionsByCode, currency } = useContext(HotelContext)
  const { language, RoomOccupation, requestCreate } = useContext(UserContext)
  const { data: checkIn } = useContext(CheckInContext);
  const [data, setData] = useState(null);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  // const [showDateSelector, setShowDateSelector] = useState(false);

  const [dataOptions, setDataOptions] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  // const [dataSettings, setDataSettings] = useState(null);
  const [selectedSetting, setSelectedSetting] = useState(null);
  const [selectedOmmitPayment, setSelectedOmmitPayment] = useState(false);

  const [dataFormReadyToCart, setDataFormReadyToCart] = useState(null);

  const [scrollToBottom, setScrollToBottom] = useState(0);

  // Carrito
  const [cart, setCart] = useState(null);

  const [redirectIsCounting, setRedirectIsCounting] = useState(false);
  const [redirectCount, setRedirectCount] = useState(8);

  const { getUpselling } = useUpsell();

  useEffect(() => {
    getUpselling(id).then(r => {
      setData(r);
    });
  }, [id]);

  useEffect(() => {
    // Solo activa el intervalo si isCounting es true
    if (redirectIsCounting) {
      const interval = setInterval(() => {
        setRedirectCount((prevCount) => prevCount - 1);
      }, 1000);

      // Redirecciona cuando el contador llegue a 0
      if (redirectCount === 0) {
        navigate(`/${hotel.code}/checkin/status`)
      }

      // Limpia el intervalo al desmontar el componente o cuando count llegue a 0
      return () => clearInterval(interval);
    }
  }, [redirectIsCounting, redirectCount, navigate]);

  const handleBack = () => {
    console.log('step', step);
    if (step == "form" && selectedOption) {
      console.log('6feb aca 1');
      setSelectedOption(null);
      return;
    }
    if (step == "cart") {
      setCart(null);
      return;
    }

    window.history.back();
  }

  const onBuy = useCallback(() => {
    console.log('21feb currentOption', currentOption);
    console.log('21feb dataFormReadyToCart', dataFormReadyToCart);

    // Paquete (type "items"): añadir al carrito o enviar solicitud directa si es "sujeto a disponibilidad"
    if (data?.type === "items") {
      const cupBase = {
        id: data.id,
        title: data.title,
        titleI18n: data.titleI18n,
        description: data.description,
        descriptionI18n: data.descriptionI18n,
        price: data.price,
        photo: data.photo,
        availabilityStatus: data.availabilityStatus,
        type: "items",
      };
      const cup = {
        ...cupBase,
        optionSelected: {
          id: data.id,
          name: data.title,
          nameI18n: data.titleI18n,
          price: data.price,
          qty: 1,
          type: "items",
          items: data.options ?? [],
        },
      };
      setOpenModal(false);
      // Sujeto a disponibilidad: no se cobra ahora; enviar solicitud directa sin paso de pago
      if (data.availabilityStatus === true) {
        saveRequest(cup);
        return;
      }
      if (isAlvarezArguellez(checkIn?.hotelId) && checkIn?.status == "in_stay") {
        saveRequest(cup);
      } else {
        setCart(cup);
      }
      return;
    }

    let day = "";
    let allDay = null;
    let hour = "";
    let qty = 1;
    let multiplyPrice = 1;

    const cupBase = {
      id: data.id,
      title: data.title,
      titleI18n: data.titleI18n,
      description: data.description,
      descriptionI18n: data.descriptionI18n,
      price: data.price,
      photo: data.photo,
      availabilityStatus: data.availabilityStatus,
    };

    if (dataFormReadyToCart) {
      day = dataFormReadyToCart.day;
      allDay = dataFormReadyToCart.allDay;
      hour = dataFormReadyToCart.hour;
      qty = dataFormReadyToCart.qty;
      multiplyPrice = dataFormReadyToCart.multiplyPrice ? parseInt(dataFormReadyToCart.qty) : 1;
    }
    const formattedHour = hour?.endsWith(":00") ? hour.split(":")[0] : hour;

    const itemsOrOptions = data.options ?? data.items ?? [];
    console.log('21feb - data.options / items', itemsOrOptions);

    const bookable = (itemsOrOptions[0]?.bookableItemId && day && (hour || allDay))
      ? {
        day: day,
        allDay: allDay,
        hour: formattedHour,
        qty: qty,
        service: {
          id: itemsOrOptions[0].bookableItemId,
          name: data.title,
        },
      }
      : null;

    console.log('21feb - bookable', bookable)

    let cup = bookable ? { ...cupBase, bookable } : cupBase;

    console.log('21feb - cup', cup)

    if (currentOption) {
      cup.optionId = currentOption.id;
      cup.optionSelected = { ...currentOption };
      if (currentOption.values) {
        cup.optionSelected.values = currentOption.values;
      }
      // ✅ Si currentOption es tipo "settings" con total calculado, usarlo como price
      // (porque data.price podría ser 0 para upsellings con fecha-selector)
      if (currentOption.type === "settings" && currentOption.price != null && currentOption.price > 0) {
        cup.price = currentOption.price;
        // ✅ NO aplicar multiplyPrice porque el total ya fue calculado por QuestionTotals / cantidad
        multiplyPrice = 1;
      }
      if (dataFormReadyToCart?.qty > 1) {
        cup.optionSelected.qty = dataFormReadyToCart.qty;
      }
      if (currentOption.type === "settings" && selectedSetting?.length) {
        cup.settingData = {
          qty: cup.optionSelected.qty ?? (getQuantityFromValues(selectedSetting, currentOption.settings) || 1),
          price: currentOption.basePrice ?? currentOption.price ?? data.price,
          total: cup.optionSelected.price,
          values: JSON.stringify(selectedSetting)
        };
      }
    }
    if (multiplyPrice > 1) {
      cup.price = multiplyPrice * cup.price;
      cup.optionSelected.price = multiplyPrice * cup.optionSelected.price;
    }

    setOpenModal(false);
    // si es alvarez arguellez,se crea el request sin necesidad de pagar, sino, se agrega al carrito y se muestra el modal de pago
    if (isAlvarezArguellez(checkIn?.hotelId) && checkIn?.status == "in_stay") {
      saveRequest(cup);
    }
    else {
      setCart(cup);
    }
    console.log('21feb setCart', cup);

    return;

    if (!withPaymentStep) {
      // Creo el request, demoro y redirecciono
      saveRequest(cup);
    }

  }, [data, selectedOption, selectedSetting, dataFormReadyToCart]);

  // const { showBuyActions, showOptionsSelector } = useMemo(() => {
  //   let auxShowBuyActions = true;

  //   if (dataOptions) {
  //     if (dataOptions.lenght > 1) {

  //     }
  //   }
  //   if (!dataSettings) {
  //     auxShowBuyActions = false;
  //   }

  //   return { showBuyActions: auxShowBuyActions }
  // }, [dataSettings, dataOptions]);



  useEffect(() => {
    if (data?.type === "items") return; // Paquete: no auto-seleccionar opción
    if (data?.options?.length == 1) {
      if (data.options[0].id) {
        setSelectedOption(data.options[0].id);
      } else {
        setSelectedOption(null);
      }
    }
  }, [data]);

  const currentOption = useMemo(() => {
    if (!selectedOption) return null;
    const originalOpt = data.options.find(option => option.id === selectedOption);
    let opt = { ...originalOpt }
    opt.type = "options";
    // ✅ Guardar el precio base original para usar en Settings.js
    opt.basePrice = originalOpt.price;
    if (selectedSetting) {
      console.log('12feb selectedSetting', selectedSetting);
      if (selectedSetting.length == 1 && selectedSetting[0].qty) {
        opt.type = "settings";
        opt.qty = parseInt(selectedSetting[0].qty);
        opt.price = parseInt(selectedSetting[0].qty) * originalOpt.price;
        opt.values = selectedSetting;
      } else {
        const totalItem = selectedSetting.find(item => item.total !== undefined && item.total > 0);
        const qtyFromValues = getQuantityFromValues(selectedSetting, originalOpt.settings);
        if (totalItem) {
          opt.type = "settings";
          opt.qty = 1;
          opt.price = parseInt(totalItem.total);
          opt.values = selectedSetting;
          console.log('12feb totalItem', totalItem);
        } else if (qtyFromValues > 0) {
          opt.type = "settings";
          opt.qty = qtyFromValues;
          opt.price = qtyFromValues * (originalOpt.price ?? 0);
          opt.values = selectedSetting;
        } else {
          // Solo fechas (date-selector): respetar hideCheckoutDate y hideToday del question
          const datesItem = selectedSetting.find(item => item.dates && Array.isArray(item.dates));
          const rawDays = (datesItem?.dates || []).map(d => String(d).slice(0, 10));
          const optSettings = typeof originalOpt?.settings === 'string'
            ? (() => { try { return JSON.parse(originalOpt.settings); } catch { return null; } })()
            : originalOpt?.settings;
          const dateSelectorQ = optSettings?.questions?.find(q => q.type === 'date-selector');
          const hideCheckoutDate = dateSelectorQ?.hideCheckoutDate ?? false;
          const hideToday = dateSelectorQ?.hideToday ?? false;

          let daysToCount = rawDays;
          if (hideCheckoutDate && checkIn?.dateEnd) {
            const checkoutNorm = String(checkIn.dateEnd).slice(0, 10);
            daysToCount = daysToCount.filter(d => d !== checkoutNorm);
          }
          if (hideToday) {
            const today = new Date();
            const todayStr = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())).toISOString().slice(0, 10);
            daysToCount = daysToCount.filter(d => d !== todayStr);
          }
          const countDays = daysToCount.length;
          const basePrice = originalOpt?.basePrice ?? originalOpt?.price ?? 0;
          if (countDays > 0 && basePrice > 0) {
            opt.type = "settings";
            opt.qty = countDays;
            opt.price = countDays * basePrice;
            opt.values = selectedSetting;
          }
        }
      }
      console.log('12feb opt', opt);
    }
    console.log('12feb currentOption', opt);
    return opt;
  }, [selectedOption, selectedSetting, checkIn]);

  // useState(() => {
  //   let opt = null;

  //   if (currentOption) {

  //     console.log('12feb aaaaaaaaa', currentOption);

  //     opt = { ...currentOption };
  //     opt.type = "options";
  //     if (selectedSetting) {
  //       opt.type = "settings";
  //       if (selectedSetting.length > 0) {
  //         if (selectedSetting[0].qty) {
  //           opt.qty = selectedSetting[0].qty;
  //         }
  //       }
  //     }
  //   }
  //   setDataFormReadyToCart(opt);
  // }, [currentOption]);

  const { step, buyDisabled } = useMemo(() => {

    console.log('6feb - step - data', data);
    let result = { step: "info", buyDisabled: false }

    if (data) {
      // Si ya hay carrito (ej. tras clic en Comprar), mostrar paso cart/pago
      if (cart) {
        if (withPaymentStep) {
          result.step = "cart";
        } else {
          result.step = "send-request";
        }
        return result;
      }
      // Paquete de productos (type "items"): sin selector de opción, listo para añadir al carrito
      if (data.type === "items") {
        result.step = "info";
        result.buyDisabled = false;
        return result;
      }
      // Selector de opción solo para type "option" (no para paquetes)
      if (data.options && !selectedOption && data.type !== "items") {
        if (data.options.length == 1) {
          result.step = "options-selector-one-option";
        } else {
          result.step = "options-selector";
          result.buyDisabled = true;
        }
      }
      // if (!cup.options) return "options-selector-one-option";
      if (currentOption && currentOption.bookableItemId) {
        result.step = "form";
        result.buyDisabled = !dataFormReadyToCart;
      }
      // Solo pasar a "settings" cuando hay questions reales.
      // Evita que settings: "{}" pise el flujo de form (bookableItemId) en web checkin.
      if (currentOption && hasSettingsQuestions(currentOption)) {
        result.step = "settings";
        // Misma lógica que Settings (web check-in): una sola función para ambos flujos
        result.buyDisabled = getSettingsBookButtonDisabled(selectedSetting || [], currentOption.settings);
      }
    }
    return result;

  }, [data, withPaymentStep, selectedOption, currentOption, selectedSetting, dataFormReadyToCart, cart])

  const handleDateSelectorClose = () => {
    if (step == "form" && data.options?.length > 1) {
      setSelectedOption(null);
      setScrollToBottom(scrollToBottom + 1);
    }
  }

  const handleChangePaymentState = (state) => {
    if (state == "done" || state == "no-payment-pending") {
      // done = pagó con tarjeta; no-payment-pending = total 0 (sin cargo)
      saveRequest(cart);
      setScrollToBottom(scrollToBottom + 1);
    }
  }
  const handleChangeOmmited = (state) => {
    setSelectedOmmitPayment(state);
    setScrollToBottom(scrollToBottom + 1);
  }
  const handleSettingsOnChange = (el) => {
    console.log('12feb - handleSettingsOnChange', el);
    if (el.length > 0) {
      setSelectedSetting(el);
      setScrollToBottom(scrollToBottom + 1);
    } else {
      setSelectedSetting(null);
    }
  }

  const renderPrice = useMemo(() => {
    if (!data) return null;
    if (shouldHidePrice(data)) {
      return null;
    }
    // Paquete (type "items"): mostrar precio del paquete
    if (data.type === "items" && data.price != null) {
      return (
        <div className="cross-up-selling-detail-modal-price" style={{ fontSize: 22, fontWeight: "bold" }}>{currencyFormat(data.price, currency)}</div>
      );
    }
    if (data?.options?.length > 1 && data?.type !== "items") {
      return (
        <div className="cross-up-selling-detail-modal-price" style={{ fontSize: 22, fontWeight: "bold" }}>{currency} {`${data.options[0].price} - ${data.options[data.options.length - 1].price}`}</div>
      )
    } else {
      if (data.price) {
        return (
          <>
            <div className="cross-up-selling-detail-modal-price" style={{ fontSize: 22, fontWeight: "bold" }}>{currencyFormat(data.price, currency)}</div>
            {data.priceIsPerNight && <div className="d-block text-muted">{T('cups.priceIsPerNight')}</div>}
          </>
        )
      } else {
        return (
          <>
            <p className="text-success text-center font-size-lg mb-0">
              <b>{T("general.no-charge")}</b>
            </p>
          </>
        )
      }
    }
  }, [data])

  const saveRequest = (data) => {
    console.log('29dic - saveRequest - data', data);
    let requestData = { ...data };
    // Id del cross-selling en catálogo (mismo que el builder de reviews); no confundir con Request.id ni ítems de línea.
    const catalogCupId = requestData.id;
    if (catalogCupId && !requestData.crossUpSellingId) {
      requestData.crossUpSellingId = catalogCupId;
    }
    if (requestData.optionSelected?.price) {
      requestData.price = requestData.optionSelected?.price;
    }
    if (requestData.optionSelected?.values) {
      let _extra = { ...requestData.extra, values: requestData.optionSelected?.values };
      requestData.extra = JSON.stringify(_extra);
    }
    delete (requestData.optionSelected);
    console.log('29dic - saveRequest - requestData', requestData);
    setSending(true);
    setScrollToBottom(scrollToBottom + 1);

    const payload = {
      type: 'up_selling',
      data: JSON.stringify(requestData),
    };
    requestCreate(payload)
      .then(() => {
        setSending(false);
        setSent(true);

        setRedirectCount(8);
        setRedirectIsCounting(true);

      })
      .catch((error) => {
        console.error("Error creating request:", error);
        setSending(false);
      });
  }

  if (!data) return <div className="loading d-flex justify-content-center align-items-center h-100"><div className="spinner-border" role="status"></div></div>;

  return (
    <Screen
      section="upselling-detail"
      headerTranslucid={true}
      title={i18nValue(sectionsByCode["service_upselling"], "title", language)}
      backUrl={null}
      onBackClick={() => {
        console.log('12feb back');
        if (currentOption) {
          handleBack();
          return true;
        }
      }}
      autoScrollToBottom={scrollToBottom}
    >
      <div className="header-detail-with-slider mb-3" style={{ height: "auto" }}>
        {renderPrice && <div style={{ position: "absolute", right: 10, top: 10, background: "rgba(255, 255, 255, 0.8)", padding: "8px 16px", borderRadius: 8, textAlign: "center" }}>
          {renderPrice}
        </div>}
        {data.photo ? (
          <img src={getCDNImage(data.photo)} className="page-detail-photo w-100" />
        ) : (
          <div className='w-100 d-flex justify-content-center align-items-center' style={{ backgroundColor: '#C9C9C9', height: 190 }}>
            <FontAwesomeIcon icon={faImage} style={{ color: 'white', fontSize: '110px' }} />
          </div>
        )}
      </div>
      <div className="page-detail-title mb-3 mt-1" style={{ lineHeight: 1.25 }}>{i18nValue(data, 'title', language)}</div>
      {data?.availabilityStatus && (
        <div
          style={{
            margin: "1rem 0",
            background: "#ffefbc",
            borderRadius: "8px",
            padding: "0.8rem 1rem",
            fontSize: "0.9rem",
            lineHeight: "1.1rem",
            color: "#d48200"
          }}
        >
          <b style={{ color: "#d48200", textTransform: "uppercase" }}>{T('cups.subject_to_availability')}</b>. {T('cups.subject_to_availability_text')}
        </div>
      )}
      <p className="page-detail-description text-with-break-line mb-3">{processHtml(i18nValue(data, 'description', language))}</p>

      <br />

      {/* <p className="cross-up-selling-detail-modal-price text-center mt-2">{`${currency} ${data.price}`}</p> */}

      <div className="footer-container shadow-lg">

        {/* <div>STEP: {step}</div> */}
        {/* <div>withPaymentStep: {withPaymentStep ? "SI" : "NO"}</div> */}

        {step === "info" && (
          <>
            {data?.type === "items" && data?.options?.length > 0 && (
              <div className="mb-3">
                <h6 className="mb-2 font-weight-bold">{T('services.type.items_sales')}</h6>
                <div style={{ background: "#f8f9fa", borderRadius: 8, padding: "12px 16px" }}>
                  {(data.options || []).map((opt, idx) => {
                    const qty = opt.qty ?? opt.quantity ?? 1;
                    const name = i18nValue(opt, 'name', language);
                    return (
                      <div key={opt.id || idx} className="d-flex align-items-center py-1" style={{ borderBottom: idx < data.options.length - 1 ? "1px solid #eee" : "none" }}>
                        <span className="font-size-sm">{name}{qty > 1 ? ` x${qty}` : ''}</span>
                      </div>
                    );
                  })}
                </div>
                <div className="d-flex justify-content-between align-items-center mt-2 pt-2" style={{ borderTop: "1px solid #ddd" }}>
                  <span className="font-weight-bold">{T('general.total')}</span>
                  <span className="font-weight-bold">{currencyFormat(data.price, currency)}</span>
                </div>
              </div>
            )}
            {currentOption && (
              <div className="title-container d-flex justify-content-between align-items-center">
                <h6 className="mb-0">{i18nValue(currentOption, 'name', language)}</h6>
                <h5 className="mb-0 text-nowrap">{currencyFormat(currentOption?.price, currency)}</h5>
              </div>
            )}
          </>
        )}



        {step === "options-selector" && !sending &&
          <div className="options-selector">
            <h6 className="mt-1 mb-3 text-center font-weight-bold">{T('general.select_option')}</h6>
            {data.options?.map((opt, idx) => {
              return <div
                style={{
                  background: "white",
                  border: "1px solid #DDD",
                  color: "#666",
                  padding: "10px 15px",
                  borderRadius: 8,
                  marginBottom: 8
                }}
                onClick={() => setSelectedOption(opt.id)}
              >
                <div className="d-flex justify-content-between align-items-center" style={{ gap: 30 }}>
                  <h6 className="mb-0">{i18nValue(opt, 'name', language)}</h6>
                  <h5 className="mb-0 text-nowrap font-size-md font-weight-bold">{currencyFormat(opt.price, currency)}</h5>
                </div>
              </div>
            })}
          </div>
        }

        {step === "form" && !sending && <>
          <div className="upselling-current-data">
            <div className="title-container d-flex justify-content-between align-items-center">
              <h6 className="mb-0">{i18nValue(currentOption, 'name', language)}</h6>
              <h5 className="mb-0 text-nowrap">{currencyFormat(currentOption?.price, currency)}</h5>
            </div>
            <div className="form-container">
              <DateSelector
                // setShowDateSelector={setShowDateSelector}
                // showDateSelector={showDateSelector}
                bookableItemId={currentOption.bookableItemId}
                setShowDateSelector={() => { }}
                showDateSelector={true}
                showButtons={false}
                //handleAddToCart={onBuy}
                setDataReadyToCart={setDataFormReadyToCart}
                onCancel={handleDateSelectorClose}
              />
            </div>
          </div>
        </>
        }

        {step === "settings" && !sending && <>
          <h6 className="mt-1 mb-3 text-center font-weight-bold">{T('general.customization')}</h6>
          <div className="settings-container">
            <Settings
              settings={parseOptionSettings(currentOption.settings) || []}
              addon={currentOption}
              currency={currency}
              handleOnChange={handleSettingsOnChange}
              showButtons={false}
              language={language}
              checkin={checkIn} />
          </div>
        </>
        }


        {step === "cart" && !sent && !sending && (
          <>
            <PaymentCart
              checkIn={checkIn}
              data={cart}
              language={language}
              currency={checkIn.balance?.currency || "CHF"}
              onChangeState={handleChangePaymentState}
              onChangeOmmited={handleChangeOmmited}
              paymentOmmitedFromParent={selectedOmmitPayment}
              config={{
                optionPayLater: shouldShowUpsellingPayLaterOption(hotel?.id),
                isUpselling: true
              }}
            />
            {redirectIsCounting && (
              <div>
                <small className="d-block text-center mt-1">
                  {TF("checkin.redirecting", [redirectCount])}
                </small>
              </div>
            )}
          </>
        )}


        {sending && (
          <div className="loading text-center my-5">
            <div className="spinner-border" role="status"></div>
            <div className="mt-2">Sending data...</div>
          </div>
        )}


        {!cart && !sending && !sent && (
          <Row className="flex-fill pt-4">
            <Col xs={6} className={"p-0 pr-1"}>
              <Button
                size={"lg"}
                variant={"secondary"}
                type={"button"}
                block={true}
                onClick={handleBack}
              >
                <FontAwesomeIcon icon={faArrowCircleLeft} className="mr-2" />{" "}
                {T("general.back")}
              </Button>
            </Col>
            <Col xs={6} className={"p-0 pl-1"}>
              <Button
                size={"lg"}
                variant={"success"}
                type={"button"}
                block={true}
                onClick={() => withPaymentStep ? onBuy() : setOpenModal(true)}
                disabled={buyDisabled}
              >
                <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />{" "}
                {isAlvarezArguellez(checkIn?.hotelId) ? T("general.request") : T("general.buy")}
              </Button>
            </Col>
          </Row>
        )}

        {(!sending && !sent && cart && selectedOmmitPayment) && (
          <Row className="flex-fill pt-4">
            <Col xs={6} className={"p-0 pr-1"}>
              <Button
                size={"lg"}
                variant={"secondary"}
                type={"button"}
                block={true}
                onClick={handleBack}
              >
                <FontAwesomeIcon icon={faArrowCircleLeft} className="mr-2" />{" "}
                {T("general.back")}
              </Button>
            </Col>
            <Col xs={6} className={"p-0 pl-1"}>
              <Button
                size={"lg"}
                variant={"success"}
                type={"button"}
                block={true}
                onClick={() => saveRequest(cart)}
                disabled={buyDisabled}
              >
                <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />{" "}
                {T("general.buy")}
              </Button>
            </Col>
          </Row>
        )}

        {(!sending && !sent && cart && !selectedOmmitPayment) && (
          <Row className="flex-fill pt-4">
            <Col xs={12} className="p-0">
              <Button
                size={"lg"}
                variant={"secondary"}
                type={"button"}
                block={true}
                onClick={() => {
                  setCart(null);
                  setSelectedOmmitPayment(false);
                }}
              >
                <FontAwesomeIcon icon={faArrowCircleLeft} className="mr-2" />{" "}
                {T("general.back")}
              </Button>
            </Col>
          </Row>
        )}


      </div>

      <Modal show={openModal} centered backdrop="static">
        <Modal.Header style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
          <Modal.Title className="ms-auto">
            <span className="font-size-md text-center">
              {T("cups.confirm")}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
          <div>
            <small onClick={() => setOpenModal(false)}>
              {T("general.back")}
            </small>
          </div>
          <Button variant="success" onClick={onBuy}>
            {T("general.buy")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={!sending && sent} centered backdrop="static">
        <Modal.Body className="text-center" style={{ background: "white", border: "1px solid #EEE", borderRadius: 10, padding: "10px 20px" }}>
          <span className="font-size-sm d-block mb-3">
            <FontAwesomeIcon icon={faThumbsUp} style={{ fontSize: 80, color: '#3699ff', marginTop: -20 }} className="mb-1" />
          </span>
          <p style={{ fontSize: "0.9rem" }} className="mb-0">
            {T('services.sent-text')}<br />
            <NavLink className="btn btn-secondary mt-4 mb-2 text-white" to={{ pathname: '/' + hotel.code + '/checkin/status' }} replace>
              {T('services.go-to-requests')}
            </NavLink>
          </p>
        </Modal.Body>
      </Modal>
    </Screen>
  );
}

export default UpsellingDetail;